import { useContext } from 'react';
import { appUserContext, ApplicationProvider, CustomerApplicationProvider } from 'helpers/services';
import { Redirect, Route } from 'react-router-dom';
import { CustomerLayout, SimecLayout } from 'components';
import { UserTypology } from 'helpers/Enums';
import { IconContext } from 'react-icons';


let PrivateRoute = (props: any) => {
    let { hasLoaded, isAuthorized, currentUser } = useContext(appUserContext);

    return (
        <>
            {hasLoaded === true &&
                <IconContext.Provider value={{ size: '20' }}>

                    {isAuthorized === false && <Redirect to="/error403" />}

                    {isAuthorized === true &&
                        <>
                            {props.enableUserTypes.indexOf(currentUser.typology) === -1 && <Redirect to="/error404" />}

                            {props.enableUserTypes.indexOf(UserTypology.Customer) >= 0 && currentUser.typology === UserTypology.Customer &&
                                <CustomerApplicationProvider>
                                    <CustomerLayout>
                                        <Route {...props} />
                                    </CustomerLayout>
                                </CustomerApplicationProvider>
                            }

                            {props.enableUserTypes.indexOf(UserTypology.Simec) >= 0 && currentUser.typology === UserTypology.Simec &&
                                <ApplicationProvider>
                                    <SimecLayout>
                                        <Route {...props} />
                                    </SimecLayout>
                                </ApplicationProvider>
                            }
                        </>
                    }
                </IconContext.Provider>
            }
        </>
    )
}

export default PrivateRoute;